/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EUspContractType } from "../types/EUspContractType.ts";

/**
 * @description 1 = RTC | 2 = RTP | 3 = RDIDP | 4 = Aposentado |
 */
export const eUspContractTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = RTC | 2 = RTP | 3 = RDIDP | 4 = Aposentado | ",
  ) as unknown as ToZod<EUspContractType>;
